import { EmailType } from '../../app/modules/types/email'
import { apiClient } from '../client'

/**
 * Emails API endpoints
 */
export const emailsApi = {
  /**
   * Get emails list
   */
  getList: async (params?: string): Promise<EmailType> => {
    const url = params ? `/email/?${params}` : '/email/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get email by ID
   */
  getById: async (emailId: string): Promise<any> => {
    const { data } = await apiClient.get(`/email/${emailId}/`)
    return data
  },

  /**
   * Get email statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/email/stats/')
    return data
  },

  /**
   * Get email filter options
   */
  getFilterOptions: async (): Promise<any> => {
    const { data } = await apiClient.get('/email/filter/')
    return data
  },
}
